export default __webpack_public_path__ + "static/media/fls.29c6d1c7.jpg";